import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { useLoading } from "@/composition/useLoading"
import type { ShipmentLog } from "@/models"
import usePopups from "@/stores/popupsStore"
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { useShipmentsStore } from "../store"

interface Props {
	shipment: ShipmentLog
}

const DeleteShipmentColumn: ReactiveComponent<Props> = (props) => {
	const store = useShipmentsStore()

	const popups = usePopups()
	const { runAction } = useLoading()

	async function handleDeleteClick() {
		const confirmation = await popups.confirmDelete({
			title: `Confirm Delete Shipment ${props.shipment.shipmentNumber}`,
			cancelText: "No, Don't Delete",
			deleteText: "Yes, Delete",
			width: "32rem",
			content: () => (
				<div>
					<p>
						Are you <strong>certain</strong> that you wish to delete Shipment No {props.shipment.shipmentNumber}?
					</p>
					<p class="mb-0">
						The shipment (including all attached documents) will be removed from the system completely. This action
						cannot be undone.
					</p>
				</div>
			),
		})

		if (confirmation) {
			await runAction(store.deleteShipment(props.shipment))
		}
	}

	return () => (
		<td style={{ backgroundColor: "transparent !important", border: "none" }}>
			<BootstrapButton color="danger" onClick={() => void handleDeleteClick()}>
				<Icon icon={faTrashAlt} />
			</BootstrapButton>
		</td>
	)
}

export default defineComponent(DeleteShipmentColumn, inferProps<Props>())
